import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '@app/environments/environment';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { filter } from 'rxjs/internal/operators/filter';
import { take } from 'rxjs/internal/operators/take';

@Injectable({
  providedIn: 'root',
})
export class SupabaseService {
  private _supabase = new BehaviorSubject<SupabaseClient | undefined>(undefined);
  readonly supabase$ = this._supabase.asObservable().pipe(
    filter((supabase): supabase is SupabaseClient => !!supabase),
    take(1),
  );

  private readonly platformId = inject(PLATFORM_ID);

  init() {
    if (isPlatformServer(this.platformId)) return;
    try {
      this._supabase.next(createClient(environment.supabaseUrl, environment.supabaseAnonKey));
    } catch (error) {
      console.error(error);
    }
  }
}
